import React from 'react';
import { GiCartwheel } from 'react-icons/gi';
import { Link } from 'react-router-dom';
import { SaveOnParts } from '../../SaveOnParts/SaveOnParts';


 const FullService = () => {
    return (
        <div className="services-Page">
        <main className="services-Page-main">

        <SaveOnParts/>

        <section className="Page-main__content">

            <h1 className="services-Page-main__content-mainTitle" >Full Services-£145</h1>
            <p className="Page-main__content--paragraph">
                ALL individual jobs are included, as is fitting of any and all extra parts or accessories required/requested, Eg pedals, mudguards, lights etc <br />
                The service will take up to 7 days. This is to allow for delivery of parts and potential complications
                <br></br>
                <b style={{
                    lineHeight:"40px"
                    ,
                    fontWeight:"bolder"}}>Full service includes:</b>
                <br></br>
            </p>

            <ul id="ul_list" className= "Page-main__content--paragraph" style={{
                listStyle:"none",
                listStylePosition: "inside"
        }}>
                <li><GiCartwheel/> Pickup and check over.</li>
                <li> <GiCartwheel/>A full strip down of the entire bike.</li>
                <li> <GiCartwheel/>Frame, forks and all components deep cleaned, re-lubed.</li>
                <li> <GiCartwheel/>All bearings serviced where possible or replaced.</li>
                <li><GiCartwheel/>All cables replaced where necessary.</li>
                <li><GiCartwheel/>Inner tube replaced (if punctured)</li>
                <li><GiCartwheel/>Bike re-built and setup to function as new*</li>
                <li><GiCartwheel/>Delivery to a location of your choosing.</li>
            </ul>

            <ul className="Page-main__content--partParagraph">
                <li style={{fontWeight:"bold"}}>Price does not include cost of parts except cables and innertubes.</li>
                <br></br>
                <li>I recycle/scrap all worn parts by default, please notify me when booking if you would like me to return yours with your bike. (*Replacement parts may be required for this !!)</li>
            </ul>





            <button className="Page-main__content--Button" >
                <Link to="/Booking">Book Now</Link>
            </button>

        </section>

        </main>

        </div>
    )
}

export default FullService;